/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Timeline from "../../Charts/Timeline";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface ICostSpentOnPlacementsProps {
  costSpentOnPlacements: {
    months?: Date[];
    values?: number[];
  };
  costSpentOnPlacementsWidgetLoader: boolean;
  currencySymbol: string;
}

export class CostSpentOnPlacements extends Component<ICostSpentOnPlacementsProps> {
  static propTypes = {
    costSpentOnPlacements: PropTypes.shape({
      months: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      values: PropTypes.arrayOf(PropTypes.number),
    }),
    costSpentOnPlacementsWidgetLoader: PropTypes.bool.isRequired,
    currencySymbol: PropTypes.string.isRequired,
  };

  static defaultProps = {
    costSpentOnPlacements: {
      months: [],
      yourCompany: [],
    },
  };

  render(): ReactNode {
    const {
      costSpentOnPlacements,
      costSpentOnPlacementsWidgetLoader,
      currencySymbol,
    } = this.props;
    const costSpentOnPlacementsOptions = {
      series: [
        {
          name: `Agency Fee (${currencySymbol})`,
          data: costSpentOnPlacements.values,
        },
      ],
      options: {
        height: 350,
        colors: ["#402680"],

        chart: {
          type: "line",
          offsetY: -5,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [1],
          curve: "straight",
        },
        markers: {
          size: 5,
          radius: 5,
          shape: "circle",
        },

        tooltip: {
          x: {
            formatter: function (value) {
              const date = new Date(value);
              return date.toLocaleString("default", { month: "short" });
            },
          },

          y: [
            {
              title: {
                formatter: (val: string) => val,
              },
            },
          ],
        },
        xaxis: {
          type: "datetime",
          title: {
            text: "Time",
          },
          categories: costSpentOnPlacements.months.map((date) =>
            date?.getTime()
          ),
        },
        yaxis: {
          title: {
            text: "Agency Spend",
          },
        },
        legend: {
          offsetY: 5,
          tooltipHoverFormatter: (
            val: string,
            opts: {
              w: {
                globals: { series: number[][] };
              };
              seriesIndex: number;
              dataPointIndex: number;
            }
          ) => {
            const value = `${val} - ${
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]
            } `;
            return value;
          },
        },
      },
    };

    return (
      <Fragment>
        <Wrapper className="animated fadeIn delay-5" id="rejection-rate-widget">
          <AnalyticsWidgetLoading
            text="Updating..."
            active={costSpentOnPlacementsWidgetLoader}
          />

          <Timeline
            graphOptions={costSpentOnPlacementsOptions}
            dataTestId="cost-spent-placments-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="cost-spent-placments-title"
            data-tip="Total expenditure on placements."
            data-for="cost-spent-placments-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="cost-spent-placments-title-tooltip"
              className="tooltip-max-width"
            />
            Monthly Agency Spend ({currencySymbol})
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    currencySymbol?: string;
    jobPerformanceData: {
      costSpentOnPlacements: {
        months: Date[];
        values: number[];
      };
    };
    costSpentOnPlacementsWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  costSpentOnPlacements:
    state.employerAnalytics.jobPerformanceData.costSpentOnPlacements,
  costSpentOnPlacementsWidgetLoader:
    state.employerAnalytics.costSpentOnPlacementsWidgetLoader,
});

export default connect(mapStateToProps, {})(CostSpentOnPlacements);
